import * as tslib_1 from "tslib";
import cx from 'classnames';
import { get, includes } from 'lodash';
import * as React from 'react';
import AmCharts from "../AmCharts";
import Styles from "./Charts.css";
import { DEFAULT_SETTINGS, LEGEND_SETTINGS, LineChartTypes, RESPONSIVE_SETTINGS, VALUE_AXIS_SETTINGS } from './constants';
import Utils from './utils/common';
var AUTO_ROTATE_COUNT = 5;

function getCategoryAxisConfig(chartData, additionalConfig) {
  if (additionalConfig === void 0) {
    additionalConfig = {};
  }

  var meta = chartData.meta;
  var config = {
    axisAlpha: 0,
    gridAlpha: 0,
    //    tickLength: 0,
    minHorizontalGap: 100,
    autoRotateAngle: 60,
    boldPeriodBeginning: false,
    equalSpacing: true,
    startOnAxis: true,
    markPeriodChange: false,
    minPeriod: 'mm',
    fontSize: meta.categoryFontSize,
    color: meta.categoryFontColor,
    autoRotateCount: AUTO_ROTATE_COUNT,
    parseDates: undefined,
    labelFunction: undefined
  };
  return tslib_1.__assign({}, config, additionalConfig);
}

var LineChart =
/** @class */
function (_super) {
  tslib_1.__extends(LineChart, _super);

  function LineChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          title = _a.title,
          data = _a.data,
          unit = _a.unit,
          legendPosition = _a.legendPosition,
          enabledLegendItems = _a.enabledLegendItems,
          timeRange = _a.timeRange,
          disableDownload = _a.disableDownload,
          lineChartType = _a.lineChartType,
          legendEnabled = _a.legendEnabled,
          responsive = _a.responsive,
          stacked = _a.stacked,
          smooth = _a.smooth;
      var _b = data.meta.chartOptions,
          chartOptions = _b === void 0 ? {} : _b;

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'serial',
        dataProvider: data.data,
        categoryField: data.meta.categoryField
      }); // ------------------------------
      // Graphs
      // ------------------------------


      options.graphs = data.meta.items.map(function (itemName, i) {
        var titles = data.meta.titles;
        var cleanItemName = itemName.replace(/^P\d:\s/, ''); // 'P1: Name' --> 'Name'

        var graph = tslib_1.__assign({
          type: smooth ? 'smoothedLine' : 'line',
          valueField: itemName,
          title: titles && titles[itemName] || itemName,
          fontSize: 14,
          lineAlpha: includes(data.meta.alphaGraphs, itemName) ? 0.3 : 1,
          lineThickness: data.meta.lineThickness || 1,
          fillAlphas: stacked ? 0.6 : 0,
          useLineColorForBulletBorder: true,
          hidden: enabledLegendItems && enabledLegendItems.indexOf(cleanItemName) === -1
        }, chartOptions.graphs || {});

        if (data.meta.itemColors) {
          graph.lineColor = data.meta.itemColors[i];
        }

        if (data.meta.hiddenItems) {
          graph.hidden = data.meta.hiddenItems[i];
        } // TODO: define where should balloon live. There's one more balloon in chartUtils


        graph.balloonText = [lineChartType !== LineChartTypes.TREND ? '[[category]]' : '', "<b>[[value]]</b>", "<b>[[title]] " + (unit || '') + "</b>"].join('<br/>');
        return graph;
      }); // ------------------------------
      // Value axis
      // ------------------------------

      var valueAxis = tslib_1.__assign({}, VALUE_AXIS_SETTINGS, {
        stackType: stacked ? 'regular' : 'none',
        axisAlpha: 0.2,
        dashLength: 1,
        position: 'left',
        unit: data.meta.unit || null,
        maximum: data.meta.maximum,
        minimum: data.meta.minimum
      }, chartOptions.valueAxis || {});

      options.valueAxes = [valueAxis];
      options.chartCursor = tslib_1.__assign({}, options.chartCursor, chartOptions.chartCursor); // ------------------------------
      // Category axis
      // ------------------------------

      options.categoryAxis = getCategoryAxisConfig(data, chartOptions.categoryAxis || {});
      var dateFormat = data.meta.dateFormat;

      if (dateFormat) {
        if (dateFormat !== 'auto') {
          options.dataDateFormat = dateFormat;
        }

        options.categoryAxis.parseDates = true;
      }

      if (lineChartType === LineChartTypes.PERIOD) {
        options.categoryAxis.labelFunction = function (value, dataItem) {
          return "Day " + (dataItem.dataContext.day_in_date_range + 1);
        };
      } // ------------------------------
      // Legend
      // ------------------------------


      if (legendEnabled) {
        options.legend = tslib_1.__assign({}, LEGEND_SETTINGS, {
          enabled: legendPosition !== 'none',
          position: Utils.getLegendPosition(legendPosition),
          equalWidths: get(data.meta, 'legendEqualWidths', false)
        }, chartOptions.legend || {});
      } // ------------------------------
      // Responsive
      // ------------------------------


      if (responsive) {
        options.responsive = tslib_1.__assign({}, RESPONSIVE_SETTINGS, {
          enabled: true
        });
      } // ------------------------------
      // Export
      // ------------------------------


      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      }

      return options;
    };

    return _this;
  }

  LineChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.lineChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  return LineChart;
}(React.PureComponent);

export default LineChart;